export default "__VITE_ASSET__CC9anB9A__"